<template>
  <div class="riskList">
    <div class="num-box">
      <div class="num-item gray">
        <div class="num-tit">信息提示</div>
        <div class="num-tex">共计<b>{{ num.gray }}</b>条预警</div>
        <img src="@/assets/images/xinxitishiicon.png" alt="">
      </div>
      <div class="num-item yellow">
        <div class="num-tit">黄色预警</div>
        <div class="num-tex">共计<b>{{ num.yellow }}</b>条预警</div>
        <img src="@/assets/images/huangseyujingicon.png" alt="">
      </div>
      <div class="num-item orange">
        <div class="num-tit">橙色预警</div>
        <div class="num-tex">共计<b>{{ num.orange }}</b>条预警</div>
        <img src="@/assets/images/chengseyujingicon.png" alt="">
      </div>
      <div class="num-item red">
        <div class="num-tit">红色预警</div>
        <div class="num-tex">共计<b>{{ num.red }}</b>条预警</div>
        <img src="@/assets/images/hongseyujingicon.png" alt="">
      </div>
    </div>
    <div class="table-box">
      <div class="search-flex">
        <div class="search-box">
          <el-form ref="form" :model="search" label-width="80px" class="flex">
            <el-form-item label="预警信息">
              <el-input v-model="search.keyword" :clearable="true" placeholder="请输入关键字搜索"></el-input>
            </el-form-item>
            <el-form-item label="预警时间">
              <el-date-picker
                class="inp"
                v-model="search.time"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="-"
                start-placeholder="请选择"
                end-placeholder="请选择">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="级别选择">
              <el-select v-model="search.level" :clearable="true" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in riskLevelOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="search-btn" @click="searchFun">
            <i class="iconfont icon-sousuo"></i>搜索
          </div>
          <div class="search-btn reset" @click="reset">
            <i class="iconfont icon-huanxiang"></i>重置
          </div>
        </div>
        <img src="../../../assets/images/lishijilu.png" class="lishi" alt="" @click="to('/home/historyList')">
      </div>
      <div class="list ">
        <el-table
          border
          :data="tableData"
          :header-cell-style="centerbgc"
          :cell-style="textCenter"
          style="width: 100%">
          <el-table-column
            label="序号"
            type="index"
            width="80">
          </el-table-column>
          <el-table-column
            width="160"
            label="预警">
            <template slot-scope="scope">
              <div class="btn gray" v-if="scope.row.level == 0">提示</div>
              <div class="btn yellow" v-if="scope.row.level == 1">预警</div>
              <div class="btn orange" v-if="scope.row.level == 2">预警</div>
              <div class="btn red" v-if="scope.row.level == 3">预警</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="info"
            label="信息">
          </el-table-column>
          <el-table-column
            label="描述"
            prop="instruction">
          </el-table-column>
          <el-table-column
            width="160"
            prop="day"
            label="天数">
          </el-table-column>
          <el-table-column
            width="250"
            prop="create_time"
            label="时间">
          </el-table-column>
          <el-table-column
            width="200"
            prop="status_txt"
            label="状态">
          </el-table-column>
          <el-table-column
            label="操作"
            width="300">
            <template slot-scope="scope" class="flex">
              <div class="edit" v-if="scope.row.is_queren == 2 && scope.row.status != 4" @click="upfile(scope.row,1)">
                上传保证书
              </div>
              <div class="edit"
                   v-if="scope.row.status != 4"
                   @click="upfile(scope.row,2)">提交证明材料
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="page-box">
        <el-pagination
          :current-page.sync="search.page"
          :page-size="search.limit"
          :total="search.total"
          background
          class="page-all margin-top self-end"
          layout="prev, pager, next"
          @current-change="list">
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :title="'上传'+ title"
      :before-close="handleClose"
      :visible.sync="dialogVisible"
      width="600px">

      <div class="flex justify-center align-center margin-bottom">
        <div class="upfile">
          <upload-file
            name="rongyu"
            @uploadFile="uploadFile"
          >
            <div class="btnUp" slot="upload">
              <i class="iconfont icon-iconfontzhizuobiaozhun0263"></i> 上传{{ title }}
            </div>
          </upload-file>
        </div>
        <a :href="filePath" v-if="filePath" target="_blank" class="look margin-left">查看{{ title }}</a>
      </div>
      <div class="tips">
        <i class="iconfont icon-xinxitishi"></i>注：多项证明材料请打包上传
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="upFilePath">确 定</el-button>
        <el-button  @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {riskLevelOptions} from "@/utils/const";
import UploadFile from "@/components/UploadFile";
import {statistics, warning_lst, warning_upfile} from "@/api";

export default {
  name: "riskList",
  data() {
    return {
      riskLevelOptions: riskLevelOptions,
      dialogVisible: false,
      title: '附件',
      upType: 1,
      filePath: '',
      upId: '',
      num: {
        gray: 0,
        orange: 0,
        yellow: 0,
        red: 0
      },
      search: {
        keyword: '',
        time: '',
        level: '',
        status: 0, // 默认0   4历史记录
        page: 1,
        limit: 10,
        total: 0
      },
      tableData: []
    }
  },
  components: {UploadFile},
  computed: {
    textCenter() {
      return {
        textAlign: 'center'
      }
    },
    centerbgc() {
      return {
        textAlign: 'center',
        background: '#f7f7f7'
      }
    }
  },
  created() {
    this.$emit("setActive", {
      headActive: 4
    })
    this.init()
    this.list()
  },
  methods: {
    async init() {
      let _data = await statistics()
      if (_data.status == 200) {
        this.num.gray = _data.data.gray
        this.num.orange = _data.data.orange
        this.num.yellow = _data.data.yellow
        this.num.red = _data.data.red
      }
    },
    async list() {
      let _data = await warning_lst(
        this.search.keyword,
        this.search.time ? this.search.time.join(',') : '',
        this.search.level,
        0,
        this.search.page,
        this.search.limit
      );
      if (_data.status == 200) {
        this.tableData = _data.data.data;
        this.search.total = _data.data.total;
      }
    },

    searchFun() {
      this.search.page = 1
      this.tableData = []
      this.list()
    },

    reset() {
      this.search.keyword = ''
      this.search.time = ''
      this.search.level = ''
      this.searchFun()
    },

    upfile(row, type) {
      if (type == 1) {
        this.title = '保证书';
      }
      if (type == 2) {
        this.title = '证明材料';
      }
      this.upId = row.id
      this.upType = type
      this.filePath = type == 1 ? row.chengnuoshu : row.cailiao;
      this.dialogVisible = true;
    },

    uploadFile(data) {
      // data.file.url
      this.filePath = data.file.url
    },

    async upFilePath() {
      let _data = await warning_upfile(this.upId, this.upType, this.filePath)
      if (_data.status == 200) {
        this.$message.success(_data.msg)
        this.handleClose()
        this.list()
      } else {
        this.$message.error(_data.msg)
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.upId = ''
      this.upType = ''
      this.filePath = ''
    },
    to(path) {
      this.$router.push(path)
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.riskList {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - (173px + 159px));
  background: #f3f5f7;
  padding: 20px;

  .tips {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    background-color: #fef0ef;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 14px;
    color: #f34336;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    line-height: 16px;

    i {
      font-size: 20px;
      color: #f34336;
      margin-right: 4px;
    }

    &.width {
      width: 160px;
    }
  }

  .look {
    width: 180px;
    padding: 0 10px;
    height: 36px;
    border: 1px solid #2791ff;
    color: #2791ff;
    line-height: 34px;
    text-align: center;
    font-size: 14px;
    margin-left: 10px;
    border-radius: 4px;
    display: block;
  }

  .btnUp {
    width: 180px;
    padding: 0 10px;
    height: 36px;
    margin-left: 10px;
    background-image: linear-gradient(90deg,
      #2791ff 0%,
      #81b6ff 100%);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #ffffff;

    i {
      font-size: 20px;
      color: #ffffff;
      margin-right: 5px;
      font-weight: 100;
    }
  }

  .edit {
    color: #0089ff;
    cursor: pointer;
    display: inline-block;
    margin: 0 15px;
  }

  .table-box {
    width: 100%;
    background: #ffffff;
    padding: 0 20px;
    border-radius: 10px;
    min-height: 100px;
    margin: 20px 0;

    .list {
      width: 100%;
      padding-top: 20px;

      .btn {
        width: 60px;
        height: 26px;
        border-radius: 4px;
        font-size: 14px;
        text-align: center;
        line-height: 26px;
        margin: 0 auto;

        &.gray {
          color: #8a8a8a;
          background-color: #f2f2f2;
        }

        &.yellow {
          color: #fad471;
          background-color: #fffbdd;
        }

        &.orange {
          color: #f58739;
          background-color: #ffeedd;
        }

        &.red {
          color: #f8001a;
          background-color: #ffdddd;
        }
      }
    }

    .search-flex {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: solid 2px #e3e7f0;
      padding: 20px 0;

      .lishi {
        cursor: pointer;
      }

      .search-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .search-btn {
          width: 112px;
          height: 36px;
          background-image: linear-gradient(0deg,
            #2791ff 0%,
            #81b6ff 100%);
          border-radius: 4px;
          text-align: center;
          line-height: 36px;
          font-size: 16px;
          color: #ffffff;
          margin-left: 15px;
          cursor: pointer;

          i {
            font-size: 20px;
            margin-right: 5px;
            color: #ffffff;
          }

          &.reset {
            background-image: none;
            background-color: #ffffff;
            border-radius: 4px;
            border: solid 1px #cccccc;
            line-height: 34px;
            color: #333333;

            i {
              color: #999999;
            }
          }
        }
      }

    }
  }

  .num-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-top: 5px;

    .num-item {
      width: 447px;
      flex: 1;
      height: 138px;
      padding-top: 30px;
      padding-left: 50px;
      border-radius: 10px;
      margin-right: 20px;
      position: relative;
      >img {
        position: absolute;
        right: 0;
        bottom: 0;
      }
      &.red {
        background: url('../../../assets/images/hongseyujingbgc.png') no-repeat;
        background-size: 100% 100%;

        .num-tit {
          color: #f8001a;
        }

        .num-tex {
          color: #666666;

          b {
            color: #f8001a;
          }
        }
      }

      &.orange {
        background: url('../../../assets/images/chengseyujingbgc.png') no-repeat;
        background-size: 100% 100%;

        .num-tit {
          color: #f58739;
        }

        .num-tex {
          color: #666666;

          b {
            color: #f58739;
          }
        }
      }

      &.yellow {
        background: url('../../../assets/images/huangseyujingbgc.png') no-repeat;
        background-size: 100% 100%;

        .num-tit {
          color: #fad471;

        }

        .num-tex {
          color: #666666;

          b {
            color: #fad471;
          }
        }
      }

      &.gray {
        background: url('../../../assets/images/xinxitishibgc.png') no-repeat;
        background-size: 100% 100%;

        .num-tit {
          color: #8a8a8a;
        }

        .num-tex {
          color: #666666;

          b {
            color: #8a8a8a;
          }
        }
      }

      .num-tex {
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 2px;

        b {
          font-size: 24px;
          font-weight: bold;
          margin: 0 2px;
        }
      }

      .num-tit {
        width: 100%;
        font-size: 24px;
        font-weight: bold;
        letter-spacing: 2px;
      }
    }
  }
}
</style>


